import { render, staticRenderFns } from "./Recettes.vue?vue&type=template&id=7399a4cb&scoped=true"
import script from "./Recettes.vue?vue&type=script&lang=js"
export * from "./Recettes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7399a4cb",
  null
  
)

export default component.exports